/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon24Regular = forwardRef('ArrowDCornerLeftUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1.631 9.131A.875.875 0 1 0 2.87 10.37l5.256-5.257V17A3.875 3.875 0 0 0 12 20.875h9a.875.875 0 1 0 0-1.75h-9A2.125 2.125 0 0 1 9.875 17V5.112l5.256 5.257A.875.875 0 1 0 16.37 9.13l-5.504-5.504a2.638 2.638 0 0 0-3.73 0L1.631 9.131Z" })));
});
